export const getOnboardingStep = ({
  stepName,
  action
}) => ({
  key: 'onboarding-step',
  properties: {
    action,
    'step-name': stepName.toLowerCase()
  }
});